// extracted by mini-css-extract-plugin
export default {"topic":"topic_topic__d80lw","trending_negative":"topic_trending_negative__-B1uR","trending_positive":"topic_trending_positive__tXjmF"};